import { createQueryKeys } from "@lukemorales/query-key-factory";
import { IDropdownModel } from "common/models/IDropdownModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import {
  IAdmissionYear,
  IAdmissionYearGridFilter,
  IAdmissionYearGridModel,
} from "./types";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { AdmissionYearView } from "../types/admissionYearView";

export const admissionYear = createQueryKeys("AdmissionYear", {
  list: (postModel: PostModel<IAdmissionYearGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IAdmissionYearGridModel>>(
        endpoints.admissionYear.list,
        postModel
      ),
  }),

  getById: (Id?: string | null) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IAdmissionYear>(`${endpoints.admissionYear.getById}/${Id}`),
  }),

  getAdmissionYearValues: () => ({
    queryKey: ["GetAdmissionYearValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.admissionYear.getAdmissionYearValues),
  }),

  getViewById: (Id?: string | null) => ({
    queryKey: ["modal", Id],
    queryFn: () =>
      api.get<AdmissionYearView>(`${endpoints.admissionYear.view}/${Id}`),
  }),
});
